"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const navContainer_1 = __importDefault(require("../../../components/navContainer/navContainer"));
const store_1 = require("../../../store");
const businessShareholdersDetails_1 = __importDefault(require("./businessShareholdersDetails"));
const businessShareholdersConstants_1 = require("./businessShareholdersConstants");
const businessShareholderList_1 = __importDefault(require("./businessShareholderList"));
const BusinessShareholders = () => {
    const { shareholders, messages } = (0, store_1.useAppSelector)((state) => {
        return {
            shareholders: state.home.business_data
                ? state.home.business_data.business_organization.shareholder_data
                : [],
            messages: state.home.appMessages,
        };
    });
    // Primary bank account
    const [shareholdersLocal, setShareholdersLocal] = (0, react_1.useState)(shareholders);
    const [showShareholderComponent, setShowShareholdersComponent] = (0, react_1.useState)(businessShareholdersConstants_1.SHAREHOLDER_COMPONENT_LIST);
    const [selectedShareholder, setSelectedShareholder] = (0, react_1.useState)();
    const [errors, setErrors] = (0, react_1.useState)();
    let content;
    if (showShareholderComponent === businessShareholdersConstants_1.SHAREHOLDER_COMPONENT_LIST && shareholdersLocal) {
        content = (react_1.default.createElement(businessShareholderList_1.default, { shareholders: shareholdersLocal, setShareholders: setShareholdersLocal, setShowShareholdersComponent: setShowShareholdersComponent, setSelectedShareholder: setSelectedShareholder, canContinueApplication: !!messages && !!messages.messages.length && shareholdersLocal.length > 0 }));
    }
    else if (showShareholderComponent === businessShareholdersConstants_1.SHAREHOLDER_COMPONENT_DETAILS) {
        content = (react_1.default.createElement(businessShareholdersDetails_1.default, { businessShareholder: selectedShareholder, shareholders: shareholdersLocal, setShareholders: setShareholdersLocal, setShowShareholdersComponent: setShowShareholdersComponent, setSelectedShareholder: setSelectedShareholder, errors: errors, setErrors: setErrors }));
    }
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, isLoading: false, childrenTitle: "Shareholder information" }, content));
};
exports.default = BusinessShareholders;
